import { ReactNode } from "react";

import { AppLayout } from "shared/Layout";
import { fetchSettings } from "shared/SettingsProvider/settings.helper";
import { Banner } from "ui/Banner";
import { CACHE_ONE_DAY } from "utils/config.utils";
import { withApp } from "utils/with-app.utils";
import { fetchTranslations, useI18n } from "utils/with-i18n.utils";
import { fetchSEO, withSeo } from "utils/with-seo.utils";

import { Ecology } from "./Ecology";
import { History } from "./History";
import { Reasons } from "./Reasons";
import { Vision } from "./Vision";

export const ClubPage = () => {
  const i18n = useI18n();

  return (
    <>
      <History />
      <Vision />
      <Reasons />
      <Banner content={[i18n.t("marquee.tooSmartToBuy")]} direction="right" />
      <Ecology />
    </>
  );
};

ClubPage.getLayout = (page: ReactNode, pageProps: any) => (
  <AppLayout withBanner {...pageProps}>
    {page}
  </AppLayout>
);

export async function getStaticProps() {
  const translations = await fetchTranslations(["le-club", "marquee"]);

  const seo = await fetchSEO("club");

  return {
    props: { translations, seo, settings: await fetchSettings() },
    revalidate: CACHE_ONE_DAY,
  };
}

export default withApp(ClubPage, [withSeo]);
